
import { dispatchAdminGetReports, dispatchGetUsers } from '@/store/admin/actions';
import { Component, Vue } from 'vue-property-decorator';
import { readAdminCompanyReports, readAdminUsers } from '@/store/admin/getters';
import { UserRow } from '@/store/admin/index';
import { commitSetCompanyId } from '@/store/admin/mutations';
import ReenterRequestDiaglog from './ReenterRequestDiaglog.vue';
import CompleteDiaglog from './CompleteDiaglog.vue';

@Component({
  components: {
    ReenterRequestDiaglog,
    CompleteDiaglog,
  },
})
export default class Users extends Vue {
  public headers = [
    { text: "作成日時", align: "start", value: "company_created_at" },
    { text: "企業名", value: "company_name" },
    { text: "ユーザー名", value: "user_name", groupable: false },
    { text: "メールアドレス", value: "user_email" },
    { text: "ステータス", value: "status" },
  ];
  public users: UserRow[] = [];
  public search: string = '';

  public async mounted() {
    await dispatchAdminGetReports(this.$store);
    await dispatchGetUsers(this.$store);
    this.reset();
  }

  public reset() {
    let users: UserRow[] = [];

    const adminCompanyReports = readAdminCompanyReports(this.$store);
    const adminUsers = readAdminUsers(this.$store);
    if (adminCompanyReports && adminUsers) {
      for (let user of adminUsers) {
        if (!user.is_superuser) {
          for (let companyReport of adminCompanyReports) {
            if (user.company_id == companyReport.company.id) {
              users.push({
                company_created_at: this.formatDate(new Date(companyReport.company.created_at)),
                company_name: companyReport.company.name,
                user_name: (user.last_name + ' ' + user.first_name),
                user_email: user.email,
                status: this.checkStatus(user, companyReport),
                company: companyReport.company,
              });
              break;
            }
          }
        }
      }
    }
    this.users = users;
  }

  public moveToAccountInfo(item) {
    commitSetCompanyId(this.$store, item.company.id);
    this.$router.push('/main/user/account-info');
  }

  public formatDate(date: Date | null): string {
    let formatDate = ''
    if (date) {
      formatDate = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
    }
    return formatDate;
  }

  public checkStatus(user, companyReport): string {
    let str = ''
    if (!user.setup_completed_at) {
      str = 'セットアップ未完了';
    } else {
      if (companyReport.reports.length) {
        if (companyReport.reports[companyReport.reports.length - 1].reenter_request) {
          if (companyReport.reports[companyReport.reports.length - 1].result_completed_at) {
            str = `レポート申請${(companyReport.report_count)}回目：再入力依頼`;
          } else {
            str = `レポート申請${(companyReport.report_count + 1)}回目：再入力依頼`;
          }
        } else if (companyReport.reports[companyReport.reports.length - 1].result_completed_at) {
          str = `レポート申請${companyReport.report_count}回目：出力完了`;
        } else {
          str = `レポート申請${(companyReport.report_count + 1)}回目：申請済み`;
        }
      } else {
        str = 'レポート未提出';
      }
    }
    return str
  }
}
